<template>
  <HKLModal
    ref="modal"
    :hasCancelBtn="false"
    :title="$t('tenantProjects.requestRefundConfirm')"
    size="small"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import { useRefModal } from '../../../../controls/Modal/modal.hook'
import HKLModal from '../../../../controls/Modal/HKLModal'

export default {
  components: {
    HKLModal,
  },
  setup () {
    const refModal = useRefModal()
    return {
      ...refModal,
    }
  },
}
</script>
